import FullscreenShowcase from '../components/FullscreenShowcase';
import usePageTitle from '../hooks/usePageTitle';

const Home = () => {
    usePageTitle('Home');
    return <FullscreenShowcase />;
};

export default Home;
